document.addEventListener('DOMContentLoaded', function() {
  const filterLinks = document.querySelectorAll('.c-member-marketplace__filter-link');

  filterLinks.forEach(link => {
      link.addEventListener('click', function(event) {
          event.preventDefault();
          const url = this.getAttribute('href');

          fetch(url, {
              headers: {
                  'X-Requested-With': 'XMLHttpRequest'
              }
          })
          .then(response => response.text())
          .then(html => {
              document.querySelector('.c-member-marketplace__product-grid').innerHTML = html;
          })
          .catch(error => console.error('Error:', error));
      });
  });
});